import {
  CREATE_MONTHLY_INTERNATIONAL_POWER_METER_REPORT,
  DELETE_MONTHLY_INTERNATIONAL_POWER_METER_REPORT,
  EDIT_MONTHLY_INTERNATIONAL_POWER_METER_REPORT,
  RECEIVE_MONTHLY_INTERNATIONAL_POWER_METER_REPORTS,
  REQUEST_MONTHLY_INTERNATIONAL_POWER_METER_REPORT,
  REQUEST_MONTHLY_INTERNATIONAL_POWER_METER_REPORTS_FOR_SITE_WITH_RANGE,
} from '@sophocles/entities/MonthlyInternationalPowerMeterReport/monthlyInternationalPowerMeterReportActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_MONTHLY_INTERNATIONAL_POWER_METER_REPORTS: // Read
      return state.merge(action.monthlyInternationalPowerMeterReports);
    case DELETE_MONTHLY_INTERNATIONAL_POWER_METER_REPORT: // Delete
      return state.delete(action.monthlyInternationalPowerMeterReport.toString());
    case EDIT_MONTHLY_INTERNATIONAL_POWER_METER_REPORT: // Update
    case CREATE_MONTHLY_INTERNATIONAL_POWER_METER_REPORT: // Create
    case REQUEST_MONTHLY_INTERNATIONAL_POWER_METER_REPORT:
    case REQUEST_MONTHLY_INTERNATIONAL_POWER_METER_REPORTS_FOR_SITE_WITH_RANGE:
    default:
      return state;
  }
}

export function monthlyInternationalPowerMeterReportReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_MONTHLY_INTERNATIONAL_POWER_METER_REPORT:
    case DELETE_MONTHLY_INTERNATIONAL_POWER_METER_REPORT:
    case RECEIVE_MONTHLY_INTERNATIONAL_POWER_METER_REPORTS:
    case EDIT_MONTHLY_INTERNATIONAL_POWER_METER_REPORT:
    case REQUEST_MONTHLY_INTERNATIONAL_POWER_METER_REPORT:
    case REQUEST_MONTHLY_INTERNATIONAL_POWER_METER_REPORTS_FOR_SITE_WITH_RANGE:
      return getState(state, action);
    default:
      return state;
  }
}
